
// This is for lazy loading of the apex charts vendor library;
export default {
  
  install (Vue, options) {
    let isLoaded = false
    // Vue.prototype.$isApexLoaded = isLoaded
    Vue.prototype.$loadTwilioSync = (callback) => {
      if (!isLoaded){
        const TwilioSync = () => import(/* webpackChunkName: "twilio-sync" */ 'twilio-sync');
        Vue.prototype.$TwilioSync = TwilioSync;
        isLoaded = true;
      }
      if(typeof callback === "function"){
        callback();
      }
    }
  }
  
}